/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type ContentLinkBlockQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentLinkBlockQuery = { __typename?: 'Query', contentLinkBlock?: { __typename?: 'ContentLinkBlock', id: string, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> } | null };

export type ContentDownloadAssetQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  source?: Types.InputMaybe<Types.ContentDownloadSource>;
}>;


export type ContentDownloadAssetQuery = { __typename?: 'Query', contentDownloadAssets: Array<{ __typename?: 'AssetDownloadResponse', url: string, product: { __typename?: 'ContentProduct', id: string }, paymentRequired?: { __typename?: 'ContentPaymentRequired', status: string, paymentUrl: string } | null }> };

export type ContentIncreaseDownloadCountMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  source?: Types.InputMaybe<Types.ContentDownloadSource>;
}>;


export type ContentIncreaseDownloadCountMutation = { __typename?: 'Mutation', contentIncreaseDownloadCount: boolean };

export type ContentFavoriteProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentFavoriteProductMutation = { __typename?: 'Mutation', contentFavoriteProduct: boolean };

export type ContentUnfavoriteProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentUnfavoriteProductMutation = { __typename?: 'Mutation', contentUnfavoriteProduct: boolean };

export type ContentIsProductFavoritedQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentIsProductFavoritedQuery = { __typename?: 'Query', contentIsProductFavorited: boolean };

export type ContentCountFavoritesQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentCountFavoritesQuery = { __typename?: 'Query', contentCountFavorites: { __typename?: 'ContentProductFavoriteCount', total: number, users: Array<{ __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null }> } };

export type ContentTotalCountFavoritesQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentTotalCountFavoritesQuery = { __typename?: 'Query', contentCountFavorites: { __typename?: 'ContentProductFavoriteCount', total: number } };

export type ContentFetchMetadataDataQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
}>;


export type ContentFetchMetadataDataQuery = { __typename?: 'Query', contentFetchCategory: { __typename?: 'ContentCategory', name: string, totalProducts: number, slug: string, alternativeSlugs: Array<{ __typename?: 'ContentCategorySlug', language: Types.ContentLanguage, slug: string }>, seo: { __typename?: 'ContentCategorySEO', title: string, description: string }, root?: { __typename?: 'ContentCategory', id: string } | null }, contentListProducts: { __typename?: 'ContentPagination', pages: number } };

export type ContentFetchCategoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentFetchCategoryQuery = { __typename?: 'Query', contentFetchCategory: { __typename?: 'ContentCategory', id: string, parentId: string, name: string, slug: string, contentTop: string, totalProducts: number, root?: { __typename?: 'ContentCategory', id: string } | null } };

export type ContentListProductsQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
  language: Types.ContentLanguage;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ContentListProductsQuery = { __typename?: 'Query', contentListProducts: { __typename?: 'ContentPagination', categoryId: string, currentPage: number, type: Types.ContentPaginationType, pages: number, limit: number, products: Array<{ __typename?: 'ContentProduct', title: string, slug: string, id: string, author_id: string, publicAssets: Array<{ __typename?: 'ContentAsset', type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }> }> } };

export type ContentSearchCategoryQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  parentId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  language: Types.ContentLanguage;
}>;


export type ContentSearchCategoryQuery = { __typename?: 'Query', contentSearchCategory: Array<{ __typename?: 'ContentCategory', id: string, name: string, slug: string }> };

export type ContentListProductsV2QueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
  language: Types.ContentLanguage;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ContentListProductsV2Query = { __typename?: 'Query', contentListProductsV2: { __typename?: 'ContentPaginationV2', categoryId: string, currentPage: number, type: Types.ContentPaginationType, pages: number, products: Array<{ __typename?: 'ContentProductPreview', title: string, slug: string, id: string, authorId: string, previewPath: string, previewWidth: number, previewHeight: number }> } };

export type ContentFetchProductQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentFetchProductQuery = { __typename?: 'Query', contentProduct?: { __typename?: 'ContentProduct', id: string, title: string, slug: string, description: string, views_count: number, downloads_count: number, created_at: any, tags?: Array<string> | null, status: Types.ContentProductStatus, licenses: Array<{ __typename?: 'ContentLicense', key: string, createdAt: any }>, category: { __typename?: 'ContentCategory', id: string, name: string, slug: string, root?: { __typename?: 'ContentCategory', id: string, name: string, slug: string, totalProducts: number } | null }, linkBlocks: Array<{ __typename?: 'ContentLinkBlock', id: string, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> }>, assets: Array<{ __typename?: 'ContentAsset', id: string, downloadable: boolean, type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, size_bytes: number, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }>, publicAssets: Array<{ __typename?: 'ContentAsset', type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }>, alternativeSlugs?: Array<{ __typename?: 'ContentAlternativeSlug', language: Types.ContentLanguage, slug: string }> | null } | null };

export type ContentFetchReviewsQueryVariables = Types.Exact<{
  input: Types.ContentProductReviewsInput;
}>;


export type ContentFetchReviewsQuery = { __typename?: 'Query', contentProductReviews: { __typename?: 'ContentProductReviews', cursor: string, rating: { __typename?: 'ContentReviewRating', average: number, count: number, groups: Array<{ __typename?: 'ContentReviewRatingGroup', rating: number, count: number }> }, reviews: Array<{ __typename?: 'ContentReview', id: string, parentId?: string | null, userId: string, rating?: number | null, body: string, createdAt: any, user: { __typename?: 'PublicUserProfile', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null } }> } };

export type ContentFetchLicenseQueryVariables = Types.Exact<{
  input: Types.ContentFetchLicenseInput;
}>;


export type ContentFetchLicenseQuery = { __typename?: 'Query', contentFetchLicense?: { __typename?: 'ContentLicense', key: string } | null };

export type ContentCreateReviewMutationVariables = Types.Exact<{
  productId: Types.Scalars['String']['input'];
  parentId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  rating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  body: Types.Scalars['String']['input'];
  getInTouch?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ContentCreateReviewMutation = { __typename?: 'Mutation', contentCreateReview: boolean };

export type ContentEditReviewMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['ID']['input'];
  rating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  body: Types.Scalars['String']['input'];
}>;


export type ContentEditReviewMutation = { __typename?: 'Mutation', contentEditReview: boolean };

export type ContentMyReviewQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentMyReviewQuery = { __typename?: 'Query', contentMyReview?: { __typename?: 'ContentReview', id: string, rating?: number | null, body: string, createdAt: any } | null };

export type ContentProductStatsQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentProductStatsQuery = { __typename?: 'Query', contentProductStats: { __typename?: 'ContentProductStats', downloads: number, views: number, favorites: number } };

export type ContentLicenseCountQueryVariables = Types.Exact<{
  includeFree?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  currentSubscriptionOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ContentLicenseCountQuery = { __typename?: 'Query', contentLicenseCount: number };

export type ContentProductRecentlyViewedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentProductRecentlyViewedQuery = { __typename?: 'Query', contentProduct?: { __typename?: 'ContentProduct', id: string, title: string, user_id: string, views_count: number, downloads_count: number, slug: string, assets: Array<{ __typename?: 'ContentAsset', downloadable: boolean, type: Types.ContentAssetType, file_path: string, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }>, category: { __typename?: 'ContentCategory', root?: { __typename?: 'ContentCategory', id: string, name: string, slug: string } | null } } | null };

export type MarketplaceListProductsQueryVariables = Types.Exact<{
  input: Types.MarketplaceListProductsInput;
}>;


export type MarketplaceListProductsQuery = { __typename?: 'Query', marketplaceListProducts: { __typename?: 'MarketplaceListProductsResponse', categoryPageData?: { __typename?: 'MarketplaceCategoryPageData', pageContent?: { __typename?: 'MarketplaceCategoryPageContent', title: string, description: string, footer: string, faq: Array<{ __typename?: 'MarketplaceCategoryPageFaqItem', question: string, answer: string }> } | null, seo?: { __typename?: 'MarketplaceCategoryPageSeo', title: string, description: string, image: string, canonicalUrl: string } | null, relatedCategories: Array<{ __typename?: 'MarketplaceCategoryPageRelatedCategoriesItem', title: string, slug: string, image: string, childCategories: Array<{ __typename?: 'MarketplaceCategoryPageRelatedCategoriesItem', title: string, slug: string, image: string, childCategories: Array<{ __typename?: 'MarketplaceCategoryPageRelatedCategoriesItem', title: string, slug: string, image: string, childCategories: Array<{ __typename?: 'MarketplaceCategoryPageRelatedCategoriesItem', title: string, slug: string, image: string }> }> }> }>, breadcrumb: Array<{ __typename?: 'MarketplaceCategoryPageBreadcrumbItem', title: string, slug: string }>, linkBlocks: Array<{ __typename?: 'ContentLinkBlock', id: string, type: Types.ContentLinkBlockType, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> }>, articles: Array<{ __typename?: 'MarketplaceArticle', title: string, image: string, url: string, text: string }> } | null, products?: Array<{ __typename?: 'MarketplaceProduct', productId: string, legacyProductId: number, productUrl: string, productImage: string, productTitle: string, cardCategory: string, productCountdown: string, designer: { __typename?: 'MarketplaceProductDesigner', designerId: number }, categoriesDetails?: Array<{ __typename?: 'ProductCategoryDetails', title: string, slug: string } | null> | null, mainImageSizes?: { __typename?: 'MarketplaceImageSizes', woocommerceSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, woocommerceThumbnail?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, shopSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, mainImage?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null } | null }> | null, pagination?: { __typename?: 'MarketplacePagination', totalCount: number, pageSize: number, currentPage: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type MarketplaceListProductsForTagPageQueryVariables = Types.Exact<{
  input: Types.MarketplaceListProductsInput;
}>;


export type MarketplaceListProductsForTagPageQuery = { __typename?: 'Query', marketplaceListProducts: { __typename?: 'MarketplaceListProductsResponse', tagPageData?: { __typename?: 'MarketplaceTagPageData', pageContent?: { __typename?: 'MarketplaceTagPageContent', title: string, description: string } | null, seo?: { __typename?: 'MarketplaceTagPageSeo', title: string, description: string, image: string, canonicalUrl: string } | null, relatedTags?: Array<{ __typename?: 'MarketPlaceTagPageRelatedTagsItem', title: string, slug: string }> | null } | null, products?: Array<{ __typename?: 'MarketplaceProduct', productId: string, legacyProductId: number, productUrl: string, productImage: string, productTitle: string, cardCategory: string, productCountdown: string, designer: { __typename?: 'MarketplaceProductDesigner', designerId: number }, categoriesDetails?: Array<{ __typename?: 'ProductCategoryDetails', title: string, slug: string } | null> | null, mainImageSizes?: { __typename?: 'MarketplaceImageSizes', woocommerceSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, woocommerceThumbnail?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, shopSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, mainImage?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null } | null }> | null, pagination?: { __typename?: 'MarketplacePagination', totalCount: number, pageSize: number, currentPage: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type MarketplaceListPromoProductsQueryVariables = Types.Exact<{
  input: Types.MarketplaceListPromoProductsInput;
}>;


export type MarketplaceListPromoProductsQuery = { __typename?: 'Query', marketplaceListPromoProducts: { __typename?: 'MarketplaceListPromoProductsResponse', products?: Array<{ __typename?: 'MarketplaceProduct', productId: string, legacyProductId: number, productUrl: string, productImage: string, productTitle: string, cardCategory: string, productCountdown: string, designer: { __typename?: 'MarketplaceProductDesigner', designerId: number }, categoriesDetails?: Array<{ __typename?: 'ProductCategoryDetails', title: string, slug: string } | null> | null, mainImageSizes?: { __typename?: 'MarketplaceImageSizes', woocommerceSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, woocommerceThumbnail?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, shopSingle?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null, mainImage?: { __typename?: 'MarketplaceImageItem', url: string, width: number, height: number } | null } | null }> | null, pagination?: { __typename?: 'MarketplacePagination', totalCount: number, pageSize: number, currentPage: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };


export const ContentIncreaseDownloadCountDocument = `
mutation contentIncreaseDownloadCount($productId: ID!, $source: ContentDownloadSource) {
  contentIncreaseDownloadCount(productId: $productId, source: $source)
}

`

export const contentIncreaseDownloadCountMutationKey = 'contentIncreaseDownloadCount'

export function contentIncreaseDownloadCountMutationFetcher(variables: ContentIncreaseDownloadCountMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentIncreaseDownloadCountMutation, ContentIncreaseDownloadCountMutationVariables>(ContentIncreaseDownloadCountDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useContentIncreaseDownloadCountMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ContentIncreaseDownloadCountMutation, E, ContentIncreaseDownloadCountMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ContentIncreaseDownloadCountMutation, E, ContentIncreaseDownloadCountMutationVariables, C>({
        ...options,
        mutationKey: [contentIncreaseDownloadCountMutationKey],
        mutationFn: (variables: ContentIncreaseDownloadCountMutationVariables) => contentIncreaseDownloadCountMutationFetcher(variables, fetchOptions),
    })
}

export const ContentFavoriteProductDocument = `
mutation contentFavoriteProduct($productId: ID!) {
  contentFavoriteProduct(productId: $productId)
}

`

export const contentFavoriteProductMutationKey = 'contentFavoriteProduct'

export function contentFavoriteProductMutationFetcher(variables: ContentFavoriteProductMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFavoriteProductMutation, ContentFavoriteProductMutationVariables>(ContentFavoriteProductDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useContentFavoriteProductMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ContentFavoriteProductMutation, E, ContentFavoriteProductMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ContentFavoriteProductMutation, E, ContentFavoriteProductMutationVariables, C>({
        ...options,
        mutationKey: [contentFavoriteProductMutationKey],
        mutationFn: (variables: ContentFavoriteProductMutationVariables) => contentFavoriteProductMutationFetcher(variables, fetchOptions),
    })
}

export const ContentUnfavoriteProductDocument = `
mutation contentUnfavoriteProduct($productId: ID!) {
  contentUnfavoriteProduct(productId: $productId)
}

`

export const contentUnfavoriteProductMutationKey = 'contentUnfavoriteProduct'

export function contentUnfavoriteProductMutationFetcher(variables: ContentUnfavoriteProductMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentUnfavoriteProductMutation, ContentUnfavoriteProductMutationVariables>(ContentUnfavoriteProductDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useContentUnfavoriteProductMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ContentUnfavoriteProductMutation, E, ContentUnfavoriteProductMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ContentUnfavoriteProductMutation, E, ContentUnfavoriteProductMutationVariables, C>({
        ...options,
        mutationKey: [contentUnfavoriteProductMutationKey],
        mutationFn: (variables: ContentUnfavoriteProductMutationVariables) => contentUnfavoriteProductMutationFetcher(variables, fetchOptions),
    })
}

export const ContentCreateReviewDocument = `
mutation contentCreateReview($productId: String!, $parentId: String, $rating: Int, $body: String!, $getInTouch: Boolean) {
  contentCreateReview(
    input: {productId: $productId, parentId: $parentId, rating: $rating, body: $body, getInTouch: $getInTouch}
  )
}

`

export const contentCreateReviewMutationKey = 'contentCreateReview'

export function contentCreateReviewMutationFetcher(variables: ContentCreateReviewMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentCreateReviewMutation, ContentCreateReviewMutationVariables>(ContentCreateReviewDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useContentCreateReviewMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ContentCreateReviewMutation, E, ContentCreateReviewMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ContentCreateReviewMutation, E, ContentCreateReviewMutationVariables, C>({
        ...options,
        mutationKey: [contentCreateReviewMutationKey],
        mutationFn: (variables: ContentCreateReviewMutationVariables) => contentCreateReviewMutationFetcher(variables, fetchOptions),
    })
}

export const ContentEditReviewDocument = `
mutation contentEditReview($reviewId: ID!, $rating: Int, $body: String!) {
  contentEditReview(input: {id: $reviewId, rating: $rating, body: $body})
}

`

export const contentEditReviewMutationKey = 'contentEditReview'

export function contentEditReviewMutationFetcher(variables: ContentEditReviewMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentEditReviewMutation, ContentEditReviewMutationVariables>(ContentEditReviewDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useContentEditReviewMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ContentEditReviewMutation, E, ContentEditReviewMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ContentEditReviewMutation, E, ContentEditReviewMutationVariables, C>({
        ...options,
        mutationKey: [contentEditReviewMutationKey],
        mutationFn: (variables: ContentEditReviewMutationVariables) => contentEditReviewMutationFetcher(variables, fetchOptions),
    })
}

export const ContentLinkBlockDocument = `
query contentLinkBlock($id: ID!, $language: ContentLanguage!) {
  contentLinkBlock(id: $id, language: $language) {
    id
    title
    links {
      anchor
      url
    }
  }
}

`

export const contentLinkBlockQueryRootKey = 'contentLinkBlock'

export function contentLinkBlockQueryFetcher(variables: ContentLinkBlockQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentLinkBlockQuery, ContentLinkBlockQueryVariables>(ContentLinkBlockDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentLinkBlockQueryKey(variables: ContentLinkBlockQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentLinkBlockQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentLinkBlockQueryOptions(
    variables: ContentLinkBlockQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentLinkBlockQuery, unknown, ContentLinkBlockQuery, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentLinkBlockQueryKey(variables, fetchOptions),
        queryFn: contentLinkBlockQueryFetcher(variables, fetchOptions),
    }
}

export function useContentLinkBlockQuery<D = ContentLinkBlockQuery, E = unknown>(
    variables: ContentLinkBlockQueryVariables,
    options?: Omit<UseQueryOptions<ContentLinkBlockQuery, E, D, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentLinkBlockQuery, E, D, (ContentLinkBlockQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentLinkBlockQueryOptions(variables, fetchOptions),
    })
}

export const ContentDownloadAssetDocument = `
query contentDownloadAsset($ids: [ID!]!, $source: ContentDownloadSource) {
  contentDownloadAssets(ids: $ids, source: $source) {
    url
    product {
      id
    }
    paymentRequired {
      status
      paymentUrl
    }
  }
}

`

export const contentDownloadAssetQueryRootKey = 'contentDownloadAsset'

export function contentDownloadAssetQueryFetcher(variables: ContentDownloadAssetQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentDownloadAssetQuery, ContentDownloadAssetQueryVariables>(ContentDownloadAssetDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentDownloadAssetQueryKey(variables: ContentDownloadAssetQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentDownloadAssetQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentDownloadAssetQueryOptions(
    variables: ContentDownloadAssetQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentDownloadAssetQuery, unknown, ContentDownloadAssetQuery, (ContentDownloadAssetQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentDownloadAssetQueryKey(variables, fetchOptions),
        queryFn: contentDownloadAssetQueryFetcher(variables, fetchOptions),
    }
}

export function useContentDownloadAssetQuery<D = ContentDownloadAssetQuery, E = unknown>(
    variables: ContentDownloadAssetQueryVariables,
    options?: Omit<UseQueryOptions<ContentDownloadAssetQuery, E, D, (ContentDownloadAssetQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentDownloadAssetQuery, E, D, (ContentDownloadAssetQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentDownloadAssetQueryOptions(variables, fetchOptions),
    })
}

export const ContentIsProductFavoritedDocument = `
query contentIsProductFavorited($productId: ID!) {
  contentIsProductFavorited(productId: $productId)
}

`

export const contentIsProductFavoritedQueryRootKey = 'contentIsProductFavorited'

export function contentIsProductFavoritedQueryFetcher(variables: ContentIsProductFavoritedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentIsProductFavoritedQuery, ContentIsProductFavoritedQueryVariables>(ContentIsProductFavoritedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentIsProductFavoritedQueryKey(variables: ContentIsProductFavoritedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentIsProductFavoritedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentIsProductFavoritedQueryOptions(
    variables: ContentIsProductFavoritedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentIsProductFavoritedQuery, unknown, ContentIsProductFavoritedQuery, (ContentIsProductFavoritedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentIsProductFavoritedQueryKey(variables, fetchOptions),
        queryFn: contentIsProductFavoritedQueryFetcher(variables, fetchOptions),
    }
}

export function useContentIsProductFavoritedQuery<D = ContentIsProductFavoritedQuery, E = unknown>(
    variables: ContentIsProductFavoritedQueryVariables,
    options?: Omit<UseQueryOptions<ContentIsProductFavoritedQuery, E, D, (ContentIsProductFavoritedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentIsProductFavoritedQuery, E, D, (ContentIsProductFavoritedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentIsProductFavoritedQueryOptions(variables, fetchOptions),
    })
}

export const ContentCountFavoritesDocument = `
query contentCountFavorites($productId: ID!) {
  contentCountFavorites(productId: $productId) {
    total
    users {
      firstName
      lastName
      profileUrls {
        crafter
      }
      avatarUrl
    }
  }
}

`

export const contentCountFavoritesQueryRootKey = 'contentCountFavorites'

export function contentCountFavoritesQueryFetcher(variables: ContentCountFavoritesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentCountFavoritesQueryKey(variables: ContentCountFavoritesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentCountFavoritesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentCountFavoritesQueryOptions(
    variables: ContentCountFavoritesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentCountFavoritesQuery, unknown, ContentCountFavoritesQuery, (ContentCountFavoritesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentCountFavoritesQueryKey(variables, fetchOptions),
        queryFn: contentCountFavoritesQueryFetcher(variables, fetchOptions),
    }
}

export function useContentCountFavoritesQuery<D = ContentCountFavoritesQuery, E = unknown>(
    variables: ContentCountFavoritesQueryVariables,
    options?: Omit<UseQueryOptions<ContentCountFavoritesQuery, E, D, (ContentCountFavoritesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentCountFavoritesQuery, E, D, (ContentCountFavoritesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentCountFavoritesQueryOptions(variables, fetchOptions),
    })
}

export const ContentTotalCountFavoritesDocument = `
query contentTotalCountFavorites($productId: ID!) {
  contentCountFavorites(productId: $productId) {
    total
  }
}

`

export const contentTotalCountFavoritesQueryRootKey = 'contentTotalCountFavorites'

export function contentTotalCountFavoritesQueryFetcher(variables: ContentTotalCountFavoritesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentTotalCountFavoritesQuery, ContentTotalCountFavoritesQueryVariables>(ContentTotalCountFavoritesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentTotalCountFavoritesQueryKey(variables: ContentTotalCountFavoritesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentTotalCountFavoritesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentTotalCountFavoritesQueryOptions(
    variables: ContentTotalCountFavoritesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentTotalCountFavoritesQuery, unknown, ContentTotalCountFavoritesQuery, (ContentTotalCountFavoritesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentTotalCountFavoritesQueryKey(variables, fetchOptions),
        queryFn: contentTotalCountFavoritesQueryFetcher(variables, fetchOptions),
    }
}

export function useContentTotalCountFavoritesQuery<D = ContentTotalCountFavoritesQuery, E = unknown>(
    variables: ContentTotalCountFavoritesQueryVariables,
    options?: Omit<UseQueryOptions<ContentTotalCountFavoritesQuery, E, D, (ContentTotalCountFavoritesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentTotalCountFavoritesQuery, E, D, (ContentTotalCountFavoritesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentTotalCountFavoritesQueryOptions(variables, fetchOptions),
    })
}

export const ContentFetchMetadataDataDocument = `
query contentFetchMetadataData($categoryId: ID!, $language: ContentLanguage!, $page: Int!, $type: ContentPaginationType!) {
  contentFetchCategory(id: $categoryId, language: $language) {
    name
    totalProducts
    slug
    alternativeSlugs {
      language
      slug
    }
    seo {
      title
      description
    }
    root {
      id
    }
  }
  contentListProducts(
    categoryId: $categoryId
    language: $language
    page: $page
    type: $type
  ) {
    pages
  }
}

`

export const contentFetchMetadataDataQueryRootKey = 'contentFetchMetadataData'

export function contentFetchMetadataDataQueryFetcher(variables: ContentFetchMetadataDataQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFetchMetadataDataQuery, ContentFetchMetadataDataQueryVariables>(ContentFetchMetadataDataDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentFetchMetadataDataQueryKey(variables: ContentFetchMetadataDataQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentFetchMetadataDataQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentFetchMetadataDataQueryOptions(
    variables: ContentFetchMetadataDataQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentFetchMetadataDataQuery, unknown, ContentFetchMetadataDataQuery, (ContentFetchMetadataDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentFetchMetadataDataQueryKey(variables, fetchOptions),
        queryFn: contentFetchMetadataDataQueryFetcher(variables, fetchOptions),
    }
}

export function useContentFetchMetadataDataQuery<D = ContentFetchMetadataDataQuery, E = unknown>(
    variables: ContentFetchMetadataDataQueryVariables,
    options?: Omit<UseQueryOptions<ContentFetchMetadataDataQuery, E, D, (ContentFetchMetadataDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentFetchMetadataDataQuery, E, D, (ContentFetchMetadataDataQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentFetchMetadataDataQueryOptions(variables, fetchOptions),
    })
}

export const ContentFetchCategoryDocument = `
query contentFetchCategory($id: ID!, $language: ContentLanguage!) {
  contentFetchCategory(id: $id, language: $language) {
    id
    parentId
    name
    slug
    contentTop
    totalProducts
    root {
      id
    }
  }
}

`

export const contentFetchCategoryQueryRootKey = 'contentFetchCategory'

export function contentFetchCategoryQueryFetcher(variables: ContentFetchCategoryQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFetchCategoryQuery, ContentFetchCategoryQueryVariables>(ContentFetchCategoryDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentFetchCategoryQueryKey(variables: ContentFetchCategoryQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentFetchCategoryQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentFetchCategoryQueryOptions(
    variables: ContentFetchCategoryQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentFetchCategoryQuery, unknown, ContentFetchCategoryQuery, (ContentFetchCategoryQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentFetchCategoryQueryKey(variables, fetchOptions),
        queryFn: contentFetchCategoryQueryFetcher(variables, fetchOptions),
    }
}

export function useContentFetchCategoryQuery<D = ContentFetchCategoryQuery, E = unknown>(
    variables: ContentFetchCategoryQueryVariables,
    options?: Omit<UseQueryOptions<ContentFetchCategoryQuery, E, D, (ContentFetchCategoryQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentFetchCategoryQuery, E, D, (ContentFetchCategoryQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentFetchCategoryQueryOptions(variables, fetchOptions),
    })
}

export const ContentListProductsDocument = `
query contentListProducts($categoryId: ID!, $page: Int!, $type: ContentPaginationType!, $language: ContentLanguage!, $limit: Int) {
  contentListProducts(
    categoryId: $categoryId
    page: $page
    type: $type
    language: $language
    limit: $limit
  ) {
    categoryId
    currentPage
    type
    pages
    limit
    products {
      title
      slug
      id
      author_id
      publicAssets {
        type
        variant
        file_path
        resolution {
          width
          height
        }
      }
    }
  }
}

`

export const contentListProductsQueryRootKey = 'contentListProducts'

export function contentListProductsQueryFetcher(variables: ContentListProductsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentListProductsQuery, ContentListProductsQueryVariables>(ContentListProductsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentListProductsQueryKey(variables: ContentListProductsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentListProductsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentListProductsQueryOptions(
    variables: ContentListProductsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentListProductsQuery, unknown, ContentListProductsQuery, (ContentListProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentListProductsQueryKey(variables, fetchOptions),
        queryFn: contentListProductsQueryFetcher(variables, fetchOptions),
    }
}

export function useContentListProductsQuery<D = ContentListProductsQuery, E = unknown>(
    variables: ContentListProductsQueryVariables,
    options?: Omit<UseQueryOptions<ContentListProductsQuery, E, D, (ContentListProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentListProductsQuery, E, D, (ContentListProductsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentListProductsQueryOptions(variables, fetchOptions),
    })
}

export const ContentSearchCategoryDocument = `
query contentSearchCategory($name: String!, $parentId: String, $language: ContentLanguage!) {
  contentSearchCategory(name: $name, parentId: $parentId, language: $language) {
    id
    name
    slug
  }
}

`

export const contentSearchCategoryQueryRootKey = 'contentSearchCategory'

export function contentSearchCategoryQueryFetcher(variables: ContentSearchCategoryQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentSearchCategoryQuery, ContentSearchCategoryQueryVariables>(ContentSearchCategoryDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentSearchCategoryQueryKey(variables: ContentSearchCategoryQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentSearchCategoryQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentSearchCategoryQueryOptions(
    variables: ContentSearchCategoryQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentSearchCategoryQuery, unknown, ContentSearchCategoryQuery, (ContentSearchCategoryQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentSearchCategoryQueryKey(variables, fetchOptions),
        queryFn: contentSearchCategoryQueryFetcher(variables, fetchOptions),
    }
}

export function useContentSearchCategoryQuery<D = ContentSearchCategoryQuery, E = unknown>(
    variables: ContentSearchCategoryQueryVariables,
    options?: Omit<UseQueryOptions<ContentSearchCategoryQuery, E, D, (ContentSearchCategoryQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentSearchCategoryQuery, E, D, (ContentSearchCategoryQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentSearchCategoryQueryOptions(variables, fetchOptions),
    })
}

export const ContentListProductsV2Document = `
query contentListProductsV2($categoryId: ID!, $page: Int!, $type: ContentPaginationType!, $language: ContentLanguage!, $limit: Int) {
  contentListProductsV2(
    categoryId: $categoryId
    page: $page
    type: $type
    language: $language
    limit: $limit
  ) {
    categoryId
    currentPage
    type
    pages
    products {
      title
      slug
      id
      authorId
      previewPath
      previewWidth
      previewHeight
    }
  }
}

`

export const contentListProductsV2QueryRootKey = 'contentListProductsV2'

export function contentListProductsV2QueryFetcher(variables: ContentListProductsV2QueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentListProductsV2Query, ContentListProductsV2QueryVariables>(ContentListProductsV2Document, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentListProductsV2QueryKey(variables: ContentListProductsV2QueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentListProductsV2QueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentListProductsV2QueryOptions(
    variables: ContentListProductsV2QueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentListProductsV2Query, unknown, ContentListProductsV2Query, (ContentListProductsV2QueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentListProductsV2QueryKey(variables, fetchOptions),
        queryFn: contentListProductsV2QueryFetcher(variables, fetchOptions),
    }
}

export function useContentListProductsV2Query<D = ContentListProductsV2Query, E = unknown>(
    variables: ContentListProductsV2QueryVariables,
    options?: Omit<UseQueryOptions<ContentListProductsV2Query, E, D, (ContentListProductsV2QueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentListProductsV2Query, E, D, (ContentListProductsV2QueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentListProductsV2QueryOptions(variables, fetchOptions),
    })
}

export const ContentFetchProductDocument = `
query contentFetchProduct($id: ID!, $language: ContentLanguage!) {
  contentProduct(id: $id, language: $language) {
    id
    title
    slug
    description
    views_count
    downloads_count
    created_at
    tags
    status
    licenses {
      key
      createdAt
    }
    category {
      id
      name
      slug
      root {
        id
        name
        slug
        totalProducts
      }
    }
    linkBlocks {
      id
      title
      links {
        anchor
        url
      }
    }
    assets {
      id
      downloadable
      type
      variant
      file_path
      size_bytes
      resolution {
        width
        height
      }
    }
    publicAssets {
      type
      variant
      file_path
      resolution {
        width
        height
      }
    }
    alternativeSlugs {
      language
      slug
    }
  }
}

`

export const contentFetchProductQueryRootKey = 'contentFetchProduct'

export function contentFetchProductQueryFetcher(variables: ContentFetchProductQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFetchProductQuery, ContentFetchProductQueryVariables>(ContentFetchProductDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentFetchProductQueryKey(variables: ContentFetchProductQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentFetchProductQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentFetchProductQueryOptions(
    variables: ContentFetchProductQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentFetchProductQuery, unknown, ContentFetchProductQuery, (ContentFetchProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentFetchProductQueryKey(variables, fetchOptions),
        queryFn: contentFetchProductQueryFetcher(variables, fetchOptions),
    }
}

export function useContentFetchProductQuery<D = ContentFetchProductQuery, E = unknown>(
    variables: ContentFetchProductQueryVariables,
    options?: Omit<UseQueryOptions<ContentFetchProductQuery, E, D, (ContentFetchProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentFetchProductQuery, E, D, (ContentFetchProductQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentFetchProductQueryOptions(variables, fetchOptions),
    })
}

export const ContentFetchReviewsDocument = `
query contentFetchReviews($input: ContentProductReviewsInput!) {
  contentProductReviews(input: $input) {
    rating {
      average
      count
      groups {
        rating
        count
      }
    }
    cursor
    reviews {
      id
      parentId
      userId
      rating
      body
      createdAt
      user {
        id
        firstName
        lastName
        avatarUrl
        profileUrls {
          crafter
        }
      }
    }
  }
}

`

export const contentFetchReviewsQueryRootKey = 'contentFetchReviews'

export function contentFetchReviewsQueryFetcher(variables: ContentFetchReviewsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentFetchReviewsQueryKey(variables: ContentFetchReviewsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentFetchReviewsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentFetchReviewsQueryOptions(
    variables: ContentFetchReviewsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentFetchReviewsQuery, unknown, ContentFetchReviewsQuery, (ContentFetchReviewsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentFetchReviewsQueryKey(variables, fetchOptions),
        queryFn: contentFetchReviewsQueryFetcher(variables, fetchOptions),
    }
}

export function useContentFetchReviewsQuery<D = ContentFetchReviewsQuery, E = unknown>(
    variables: ContentFetchReviewsQueryVariables,
    options?: Omit<UseQueryOptions<ContentFetchReviewsQuery, E, D, (ContentFetchReviewsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentFetchReviewsQuery, E, D, (ContentFetchReviewsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentFetchReviewsQueryOptions(variables, fetchOptions),
    })
}

export const ContentFetchLicenseDocument = `
query contentFetchLicense($input: ContentFetchLicenseInput!) {
  contentFetchLicense(input: $input) {
    key
  }
}

`

export const contentFetchLicenseQueryRootKey = 'contentFetchLicense'

export function contentFetchLicenseQueryFetcher(variables: ContentFetchLicenseQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentFetchLicenseQuery, ContentFetchLicenseQueryVariables>(ContentFetchLicenseDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentFetchLicenseQueryKey(variables: ContentFetchLicenseQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentFetchLicenseQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentFetchLicenseQueryOptions(
    variables: ContentFetchLicenseQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentFetchLicenseQuery, unknown, ContentFetchLicenseQuery, (ContentFetchLicenseQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentFetchLicenseQueryKey(variables, fetchOptions),
        queryFn: contentFetchLicenseQueryFetcher(variables, fetchOptions),
    }
}

export function useContentFetchLicenseQuery<D = ContentFetchLicenseQuery, E = unknown>(
    variables: ContentFetchLicenseQueryVariables,
    options?: Omit<UseQueryOptions<ContentFetchLicenseQuery, E, D, (ContentFetchLicenseQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentFetchLicenseQuery, E, D, (ContentFetchLicenseQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentFetchLicenseQueryOptions(variables, fetchOptions),
    })
}

export const ContentMyReviewDocument = `
query contentMyReview($productId: ID!) {
  contentMyReview(productId: $productId) {
    id
    rating
    body
    createdAt
  }
}

`

export const contentMyReviewQueryRootKey = 'contentMyReview'

export function contentMyReviewQueryFetcher(variables: ContentMyReviewQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentMyReviewQuery, ContentMyReviewQueryVariables>(ContentMyReviewDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentMyReviewQueryKey(variables: ContentMyReviewQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentMyReviewQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentMyReviewQueryOptions(
    variables: ContentMyReviewQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentMyReviewQuery, unknown, ContentMyReviewQuery, (ContentMyReviewQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentMyReviewQueryKey(variables, fetchOptions),
        queryFn: contentMyReviewQueryFetcher(variables, fetchOptions),
    }
}

export function useContentMyReviewQuery<D = ContentMyReviewQuery, E = unknown>(
    variables: ContentMyReviewQueryVariables,
    options?: Omit<UseQueryOptions<ContentMyReviewQuery, E, D, (ContentMyReviewQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentMyReviewQuery, E, D, (ContentMyReviewQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentMyReviewQueryOptions(variables, fetchOptions),
    })
}

export const ContentProductStatsDocument = `
query contentProductStats($productId: ID!) {
  contentProductStats(id: $productId) {
    downloads
    views
    favorites
  }
}

`

export const contentProductStatsQueryRootKey = 'contentProductStats'

export function contentProductStatsQueryFetcher(variables: ContentProductStatsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentProductStatsQuery, ContentProductStatsQueryVariables>(ContentProductStatsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentProductStatsQueryKey(variables: ContentProductStatsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentProductStatsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentProductStatsQueryOptions(
    variables: ContentProductStatsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentProductStatsQuery, unknown, ContentProductStatsQuery, (ContentProductStatsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentProductStatsQueryKey(variables, fetchOptions),
        queryFn: contentProductStatsQueryFetcher(variables, fetchOptions),
    }
}

export function useContentProductStatsQuery<D = ContentProductStatsQuery, E = unknown>(
    variables: ContentProductStatsQueryVariables,
    options?: Omit<UseQueryOptions<ContentProductStatsQuery, E, D, (ContentProductStatsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentProductStatsQuery, E, D, (ContentProductStatsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentProductStatsQueryOptions(variables, fetchOptions),
    })
}

export const ContentLicenseCountDocument = `
query contentLicenseCount($includeFree: Boolean, $currentSubscriptionOnly: Boolean) {
  contentLicenseCount(
    includeFree: $includeFree
    currentSubscriptionOnly: $currentSubscriptionOnly
  )
}

`

export const contentLicenseCountQueryRootKey = 'contentLicenseCount'

export function contentLicenseCountQueryFetcher(variables?: ContentLicenseCountQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentLicenseCountQuery, ContentLicenseCountQueryVariables>(ContentLicenseCountDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentLicenseCountQueryKey(variables?: ContentLicenseCountQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentLicenseCountQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function contentLicenseCountQueryOptions(
    variables?: ContentLicenseCountQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentLicenseCountQuery, unknown, ContentLicenseCountQuery, (ContentLicenseCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentLicenseCountQueryKey(variables, fetchOptions),
        queryFn: contentLicenseCountQueryFetcher(variables, fetchOptions),
    }
}

export function useContentLicenseCountQuery<D = ContentLicenseCountQuery, E = unknown>(
    variables?: ContentLicenseCountQueryVariables,
    options?: Omit<UseQueryOptions<ContentLicenseCountQuery, E, D, (ContentLicenseCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentLicenseCountQuery, E, D, (ContentLicenseCountQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentLicenseCountQueryOptions(variables, fetchOptions),
    })
}

export const ContentProductRecentlyViewedDocument = `
query contentProductRecentlyViewed($id: ID!, $language: ContentLanguage!) {
  contentProduct(id: $id, language: $language) {
    id
    title
    assets {
      downloadable
      type
      file_path
      resolution {
        width
        height
      }
    }
    user_id
    views_count
    downloads_count
    slug
    category {
      root {
        id
        name
        slug
      }
    }
  }
}

`

export const contentProductRecentlyViewedQueryRootKey = 'contentProductRecentlyViewed'

export function contentProductRecentlyViewedQueryFetcher(variables: ContentProductRecentlyViewedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ContentProductRecentlyViewedQuery, ContentProductRecentlyViewedQueryVariables>(ContentProductRecentlyViewedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function contentProductRecentlyViewedQueryKey(variables: ContentProductRecentlyViewedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [contentProductRecentlyViewedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function contentProductRecentlyViewedQueryOptions(
    variables: ContentProductRecentlyViewedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ContentProductRecentlyViewedQuery, unknown, ContentProductRecentlyViewedQuery, (ContentProductRecentlyViewedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: contentProductRecentlyViewedQueryKey(variables, fetchOptions),
        queryFn: contentProductRecentlyViewedQueryFetcher(variables, fetchOptions),
    }
}

export function useContentProductRecentlyViewedQuery<D = ContentProductRecentlyViewedQuery, E = unknown>(
    variables: ContentProductRecentlyViewedQueryVariables,
    options?: Omit<UseQueryOptions<ContentProductRecentlyViewedQuery, E, D, (ContentProductRecentlyViewedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ContentProductRecentlyViewedQuery, E, D, (ContentProductRecentlyViewedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...contentProductRecentlyViewedQueryOptions(variables, fetchOptions),
    })
}

export const MarketplaceListProductsDocument = `
query marketplaceListProducts($input: MarketplaceListProductsInput!) {
  marketplaceListProducts(input: $input) {
    categoryPageData {
      pageContent {
        title
        description
        footer
        faq {
          question
          answer
        }
      }
      seo {
        title
        description
        image
        canonicalUrl
      }
      relatedCategories {
        title
        slug
        image
        childCategories {
          title
          slug
          image
          childCategories {
            title
            slug
            image
            childCategories {
              title
              slug
              image
            }
          }
        }
      }
      breadcrumb {
        title
        slug
      }
      linkBlocks {
        id
        type
        title
        links {
          anchor
          url
        }
      }
      articles {
        title
        image
        url
        text
      }
    }
    products {
      productId
      legacyProductId
      productUrl
      productImage
      productTitle
      cardCategory
      productCountdown
      designer {
        designerId
      }
      categoriesDetails {
        title
        slug
      }
      mainImageSizes {
        woocommerceSingle {
          url
          width
          height
        }
        woocommerceThumbnail {
          url
          width
          height
        }
        shopSingle {
          url
          width
          height
        }
        mainImage {
          url
          width
          height
        }
      }
    }
    pagination {
      totalCount
      pageSize
      currentPage
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const marketplaceListProductsQueryRootKey = 'marketplaceListProducts'

export function marketplaceListProductsQueryFetcher(variables: MarketplaceListProductsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<MarketplaceListProductsQuery, MarketplaceListProductsQueryVariables>(MarketplaceListProductsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function marketplaceListProductsQueryKey(variables: MarketplaceListProductsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [marketplaceListProductsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function marketplaceListProductsQueryOptions(
    variables: MarketplaceListProductsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<MarketplaceListProductsQuery, unknown, MarketplaceListProductsQuery, (MarketplaceListProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: marketplaceListProductsQueryKey(variables, fetchOptions),
        queryFn: marketplaceListProductsQueryFetcher(variables, fetchOptions),
    }
}

export function useMarketplaceListProductsQuery<D = MarketplaceListProductsQuery, E = unknown>(
    variables: MarketplaceListProductsQueryVariables,
    options?: Omit<UseQueryOptions<MarketplaceListProductsQuery, E, D, (MarketplaceListProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<MarketplaceListProductsQuery, E, D, (MarketplaceListProductsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...marketplaceListProductsQueryOptions(variables, fetchOptions),
    })
}

export const MarketplaceListProductsForTagPageDocument = `
query marketplaceListProductsForTagPage($input: MarketplaceListProductsInput!) {
  marketplaceListProducts(input: $input) {
    tagPageData {
      pageContent {
        title
        description
      }
      seo {
        title
        description
        image
        canonicalUrl
      }
      relatedTags {
        title
        slug
      }
    }
    products {
      productId
      legacyProductId
      productUrl
      productImage
      productTitle
      cardCategory
      productCountdown
      designer {
        designerId
      }
      categoriesDetails {
        title
        slug
      }
      mainImageSizes {
        woocommerceSingle {
          url
          width
          height
        }
        woocommerceThumbnail {
          url
          width
          height
        }
        shopSingle {
          url
          width
          height
        }
        mainImage {
          url
          width
          height
        }
      }
    }
    pagination {
      totalCount
      pageSize
      currentPage
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const marketplaceListProductsForTagPageQueryRootKey = 'marketplaceListProductsForTagPage'

export function marketplaceListProductsForTagPageQueryFetcher(variables: MarketplaceListProductsForTagPageQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<MarketplaceListProductsForTagPageQuery, MarketplaceListProductsForTagPageQueryVariables>(MarketplaceListProductsForTagPageDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function marketplaceListProductsForTagPageQueryKey(variables: MarketplaceListProductsForTagPageQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [marketplaceListProductsForTagPageQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function marketplaceListProductsForTagPageQueryOptions(
    variables: MarketplaceListProductsForTagPageQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<MarketplaceListProductsForTagPageQuery, unknown, MarketplaceListProductsForTagPageQuery, (MarketplaceListProductsForTagPageQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: marketplaceListProductsForTagPageQueryKey(variables, fetchOptions),
        queryFn: marketplaceListProductsForTagPageQueryFetcher(variables, fetchOptions),
    }
}

export function useMarketplaceListProductsForTagPageQuery<D = MarketplaceListProductsForTagPageQuery, E = unknown>(
    variables: MarketplaceListProductsForTagPageQueryVariables,
    options?: Omit<UseQueryOptions<MarketplaceListProductsForTagPageQuery, E, D, (MarketplaceListProductsForTagPageQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<MarketplaceListProductsForTagPageQuery, E, D, (MarketplaceListProductsForTagPageQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...marketplaceListProductsForTagPageQueryOptions(variables, fetchOptions),
    })
}

export const MarketplaceListPromoProductsDocument = `
query marketplaceListPromoProducts($input: MarketplaceListPromoProductsInput!) {
  marketplaceListPromoProducts(input: $input) {
    products {
      productId
      legacyProductId
      productUrl
      productImage
      productTitle
      cardCategory
      productCountdown
      designer {
        designerId
      }
      categoriesDetails {
        title
        slug
      }
      mainImageSizes {
        woocommerceSingle {
          url
          width
          height
        }
        woocommerceThumbnail {
          url
          width
          height
        }
        shopSingle {
          url
          width
          height
        }
        mainImage {
          url
          width
          height
        }
      }
    }
    pagination {
      totalCount
      pageSize
      currentPage
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const marketplaceListPromoProductsQueryRootKey = 'marketplaceListPromoProducts'

export function marketplaceListPromoProductsQueryFetcher(variables: MarketplaceListPromoProductsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<MarketplaceListPromoProductsQuery, MarketplaceListPromoProductsQueryVariables>(MarketplaceListPromoProductsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function marketplaceListPromoProductsQueryKey(variables: MarketplaceListPromoProductsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [marketplaceListPromoProductsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function marketplaceListPromoProductsQueryOptions(
    variables: MarketplaceListPromoProductsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<MarketplaceListPromoProductsQuery, unknown, MarketplaceListPromoProductsQuery, (MarketplaceListPromoProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: marketplaceListPromoProductsQueryKey(variables, fetchOptions),
        queryFn: marketplaceListPromoProductsQueryFetcher(variables, fetchOptions),
    }
}

export function useMarketplaceListPromoProductsQuery<D = MarketplaceListPromoProductsQuery, E = unknown>(
    variables: MarketplaceListPromoProductsQueryVariables,
    options?: Omit<UseQueryOptions<MarketplaceListPromoProductsQuery, E, D, (MarketplaceListPromoProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<MarketplaceListPromoProductsQuery, E, D, (MarketplaceListPromoProductsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...marketplaceListPromoProductsQueryOptions(variables, fetchOptions),
    })
}